const headers = {
  'X-Requested-With': 'XMLHttpRequest',
};

const request = async (url, method = 'GET', body = null) => fetch(url, {
  method,
  body,
  headers,
});

export default request;
